import { pick } from 'lodash-es'
import { parseCookies } from 'nookies'
import { AddressFormData } from 'modules/checkout/types'

export const getShippingAddressVariables = (
  data: AddressFormData,
  regionsAvailable: boolean
) => {
  const { firstname, lastname, company, telephone, postcode, city, street,  country_code  } = data?.shipping_address
  const addressObject = {
    address: {
      firstname,
      lastname,
      company,
      telephone,
      postcode,
      city,
      street,
      country_code,
      ...(regionsAvailable && {
        ...pick(data.shipping_address, ['region_id', 'region']),
      }),
      ...((!regionsAvailable && {
        region: null,
        region_id: null,
      }) as any),
      vat_id: null,
    },
  }
  return {
    cartId: parseCookies().cartId,
    shippingAddresses: [addressObject],
  }
}
